import { useEffect, useLayoutEffect, useState } from "react";
import * as queryString from "query-string";
import { useDispatch } from "react-redux";
import { globalActions } from "../context/global";
import { assign } from "lodash";

export const useProcessedSteamUrlSettings = (settings) => {
  const dispatch = useDispatch();
  const [urlParams, setUrlParams] = useState(null);

  useLayoutEffect(() => {
    if (typeof window !== "undefined" && window.location) {
      const searchQuery = window.location.search;
      const urlParams = queryString.parse(searchQuery);
      if (urlParams) {
        setUrlParams(urlParams);
      }
    }
  }, []);

  useEffect(() => {
    if (settings && urlParams) {
      let steamIndex = -1;
      let steamConfig = settings?.platforms?.find((platform, index) => {
        if (platform.link?.url?.includes("steam")) {
          steamIndex = index;
          return true;
        }
        return false;
      });

      const { url, query: currentSteamQueryString } = queryString.parseUrl(
        steamConfig?.link?.url?.toString() || ""
      );

      const UTMParams = Object.keys(urlParams).reduce((acc, param) => {
        if (param?.toLowerCase()?.includes("utm")) {
          acc = {
            ...acc,
            [param]: urlParams[param],
          };
        }
        return acc;
      }, []);

      const processedQueryString = assign(currentSteamQueryString, UTMParams);

      dispatch(
        globalActions.setSteamUrl(
          queryString?.stringifyUrl({ url, query: processedQueryString })
        )
      );
    }
  }, [urlParams, settings, dispatch]);

  return settings;
};

export default useProcessedSteamUrlSettings;
